import React from 'react'
import Box from '@material-ui/core/Box'
import { Typography, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import LogoIcon from '../components/LogoIcon'
import Copyright from '../components/Copyrights'
import LoginForm from '../modules/security/components/LoginForm'
import Link from '../components/Link'
import { useAuth } from '../modules/security/containers/AuthProvider'
import { useTranslation } from 'react-i18next';
import { ToggleButton } from '@material-ui/lab'

// const lngs = {
//   fr: { nativeName: 'Fr'},
//   ar: { nativeName: 'Ar'}
// };

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    paddingTop: theme.spacing(1),
  },
  loginLanguageButton: {
    fontWeight: 'bold',
    width: '70px',
    // borderRadius: '10px 0px 0px 10px',
    position: 'relative',
    top: '30px',
    left: '122px',
  }
}))

export default function Login() {

  const { t, i18n } = useTranslation()

  const classes = useStyles()
  const { login, isLoading } = useAuth()

  const lngs = {
    fr: { nativeName: i18n.language === 'fr' ? 'Fr' : 'فرنسية'},
    ar: { nativeName: i18n.language === 'fr' ? 'Ar' : 'عربية'}
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box>
        <div className= {classes.languageButton}>
            {Object.keys(lngs).map((lng) => (
              <ToggleButton
              classes={{
                selected: classes.toggleSelected,
                root: classes.toggleButton,
              }} 
              className={classes.loginLanguageButton}
                key={lng} style={{ fontWeight: i18n.resolvedLanguage === lng ? 'bold' : 'normal' }}
                type="submit" 
                onClick={() => {
                  i18n.changeLanguage(lng)
                  if(lng === 'ar')  {
                    document.getElementsByTagName('html')[0].setAttribute("dir", "rtl")
                    document.getElementsByTagName('html')[0].setAttribute("lang", "ar")
                  }
                  else {
                    document.getElementsByTagName('html')[0].setAttribute("dir", "ltr")
                    document.getElementsByTagName('html')[0].setAttribute("lang", "fr")
                  }
                  
                }}>
                  {lngs[lng].nativeName}
              </ToggleButton>
            ))}
        </div>
      </Box>

      <div className={classes.paper}>
        <LogoIcon />
        <Typography component="h1" variant="h5">
          {t('login.connexion')}
        </Typography>

        <LoginForm onSubmit={login} isLoading={isLoading} />
        <Grid container>
          <Grid item xs>
            <Link to="/forget-password">{t('login.mot_de_passe_oublie')}</Link>
          </Grid>
        </Grid>
      </div>
      
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  )
}
